import React from 'react'

import LoadingBox from 'src/ui/LoadingBox/LoadingBox'

import MyCourseHeaderSkeleton from './MyCourseHeaderSkeleton'

const MyCourseHeaderPlaceholder = () => (
  <MyCourseHeaderSkeleton
    nameSection={<LoadingBox width="135px" height="40px" maxWidth="100%" />}
    cefrLevelSection={
      <LoadingBox
        width="120px"
        height="40px"
        maxWidth="100%"
        borderRadius="1,5x"
      />
    }
  />
)

export default MyCourseHeaderPlaceholder
